module.exports = __webpack_public_path__ + "static/media/morfologia_planta.d07ea783.gif";